import React from 'react';
import './ContactLandingPage.css';
import ContactForm from './ContactForm';

function ContactLandingPage() {
  

  return (
    <div className='ContactLandingPage-form-main'>
        <div className='ContactLandingPage-header'>Transform Your Outdoors with Us</div>
        <ContactForm/>
    </div>
  );
}

export default ContactLandingPage;